module.exports = __webpack_public_path__ + "img/anchor7.8fb2a1e8.jpg";